import moment from 'moment';

const dateFilter = {
  format(date) {
    if (date != null) {
      return moment(date).format('DD-MM-YYYY');
    } else {
      return '';
    }
  }
};

export default dateFilter;
